import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'

import messages from './messages'
import s from './ApplyDiscountSuccess.scss'


class ApplyDiscountSuccessNotification extends PureComponent {

  static contextTypes = {
    close: PropTypes.func,
  }

  static propTypes = {
    onClose: PropTypes.func,
  }

  handleClick = () => {
    const { close } = this.context
    const { onClose } = this.props

    close()

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  render() {

    return (
      <Box pt="24" pb="24" className={s.item} relative onClick={this.handleClick}>
        <Text
          message={messages.text}
          html
          semibold
          uppercase
          align="center"
          size="14-24"
        />
      </Box>
    )
  }
}


export default ApplyDiscountSuccessNotification
